import React from 'react';
import MacDesktop from '../MacDesktop';

export default function AboutMeNew() {
  return <MacDesktop />;
}
